import React from 'react';
import moment from 'moment-timezone';
import uniqBy from 'lodash/uniqBy';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    Button,
    DialogActions,
    CircularProgress
} from '@material-ui/core';
import { useSwaggerClient } from '../../hooks/useSwaggerClient';

function AvailableTimeslotsModal({ activity, addToCart, showModal, MODAL_TYPE }) {
    // TODO: convert to per-day calls for Golf API compatibility
    const [timeslots, timeslotsLoading] = useSwaggerClient(
        'activities',
        'getTimeslotsForActivity',
        {
            activityId: activity.id,
            fromDate: moment().format('YYYY-MM-DD'),
            toDate: moment()
                .add({ days: 30 })
                .format('YYYY-MM-DD')
        },
        [],
        data =>
            uniqBy(
                data.timeslots
                    .filter(t => !t.disabled)
                    .sort(({ start_time: time1 }, { start_time: time2 }) =>
                        moment(time1).diff(time2)
                    ),
                e => `${e.start_time}-${e.end_time}`
            ).slice(0, 10)
    );

    return (
        <Dialog
            open
            fullWidth
            maxWidth="sm"
            onClose={() => {
                showModal(MODAL_TYPE.NONE);
            }}
        >
            <DialogTitle className="title">Available Timeslots</DialogTitle>
            <div className="modal-content">
                <DialogContent style={{ overflow: 'hidden' }}>
                    {timeslotsLoading ? (
                        <Grid container alignItems="center" direction="column">
                            <Grid item>
                                <CircularProgress />
                            </Grid>
                            <Grid item>Searching for next available timeslot...</Grid>
                        </Grid>
                    ) : timeslots && timeslots.length > 0 ? (
                        timeslots.map(timeslot => (
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={4} className="mb-2">
                                    {activity.name}{' '}
                                </Grid>
                                <Grid item xs={5} className="mb-2">
                                    {moment(timeslot.start_time).format('MMMM Do YYYY, h:mm a')}
                                </Grid>
                                <Grid item xs={3} className="mb-2">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            showModal(MODAL_TYPE.NONE);
                                            addToCart(timeslot);
                                        }}
                                    >
                                        Book now
                                    </Button>
                                </Grid>
                            </Grid>
                        ))
                    ) : (
                        <Grid container justifyContent="center">
                            <Grid item>No available timeslot in the next 30 days</Grid>
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={() => {
                            showModal(MODAL_TYPE.NONE);
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </div>
        </Dialog>
    );
}

export default AvailableTimeslotsModal;
